import React, { useState } from 'react';
import { TooltipProps, Tooltip, Typography } from '@mui/material';

type MoHoverTooltipProps = {
  titleContent: React.ReactNode | string;
  children: React.ReactElement;
} & Omit<TooltipProps, 'title' | 'children'>;

const tooltipDropShadowFilter = 'drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.15))';

export function MoHoverTooltip({ titleContent, children, ...props }: MoHoverTooltipProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);

  return (
    <Tooltip
      {...props}
      title={
        titleContent ? (
          <>
            <Typography variant="body1">{titleContent}</Typography>
          </>
        ) : null
      }
      componentsProps={{
        tooltip: {
          sx: {
            filter: tooltipDropShadowFilter,
            bgcolor: 'common.white',
            color: 'text.primary',
            padding: 1.5,
            borderRadius: 2,
            '& .MuiTooltip-arrow': {
              color: 'common.white',
              filter: tooltipDropShadowFilter,
              fontSize: 23,
              width: 25,
            },
          },
        },
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      open={isOpen}
    >
      {children}
    </Tooltip>
  );
}
